import React, { useEffect, useState } from "react";
import { api } from "../lib/api.js";
import { useI18n } from "../lib/i18n.jsx";
import ConfigurableTable, { ColumnConfigButton, useColumnConfig } from "../components/ConfigurableTable.jsx";
import SavedViewsBar from "../components/SavedViewsBar.jsx";

export default function CustomerFeedbackPage() {
  const { t } = useI18n();
  const [cases, setCases] = useState([]);
  const [bucket, setBucket] = useState("");
  const colConfig = useColumnConfig("customer_feedback");
  useEffect(() => {
    api.get("/service-cases?open_only=true").then((r) => setCases(r.data));
  }, []);

  const filtered = bucket ? cases.filter((c) => c.feedback_status === bucket) : cases;
  const buckets = {
    red: cases.filter((c) => c.feedback_status === "red").length,
    yellow: cases.filter((c) => c.feedback_status === "yellow").length,
    green: cases.filter((c) => c.feedback_status === "green").length,
    none: cases.filter((c) => c.feedback_status === "none").length,
  };

  return (
    <div className="p-4 sm:p-6 max-w-[1600px] mx-auto">
      <div className="mb-4 flex items-end justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl font-bold text-[#1A1A2E]">{t("customer_feedback")}</h1>
          <p className="text-sm text-[#6C757D] mt-1">Cross-case feedback status</p>
        </div>
        <ColumnConfigButton config={colConfig} viewKey="customer_feedback" />
      </div>
      <div className="grid grid-cols-4 gap-3 mb-4">
        <FeedBucket label="72h+ critical" count={buckets.red} color="#DC3545" active={bucket === "red"} onClick={() => setBucket(bucket === "red" ? "" : "red")} testid="feedback-bucket-red" />
        <FeedBucket label="48-72h warning" count={buckets.yellow} color="#FFC107" active={bucket === "yellow"} onClick={() => setBucket(bucket === "yellow" ? "" : "yellow")} testid="feedback-bucket-yellow" />
        <FeedBucket label="<48h on time" count={buckets.green} color="#28A745" active={bucket === "green"} onClick={() => setBucket(bucket === "green" ? "" : "green")} testid="feedback-bucket-green" />
        <FeedBucket label="Never contacted" count={buckets.none} color="#6C757D" active={bucket === "none"} onClick={() => setBucket(bucket === "none" ? "" : "none")} testid="feedback-bucket-none" />
      </div>
      <div className="mb-3 px-1">
        <SavedViewsBar viewKey="customer_feedback" config={colConfig} />
      </div>
      <ConfigurableTable viewKey="customer_feedback" config={colConfig} rows={filtered} emptyMessage="Sem registos." />
    </div>
  );
}

function FeedBucket({ label, count, color, active, onClick, testid }) {
  return (
    <button onClick={onClick} data-testid={testid} className={`text-left bg-white border rounded-md p-3 hover:border-[#1F3864] transition ${active ? "border-[#1F3864] ring-1 ring-[#1F3864]/30" : "border-gray-200"}`}>
      <div className="flex items-center gap-2 mb-1">
        <span className="w-2.5 h-2.5 rounded-full inline-block" style={{ backgroundColor: color }} />
        <span className="text-[10px] uppercase tracking-widest text-[#6C757D]">{label}</span>
      </div>
      <div className="font-heading text-2xl font-bold text-[#1A1A2E]">{count}</div>
    </button>
  );
}
